export default __webpack_public_path__ + "static/media/auohos.3bc37442.png";